import React from 'react';

interface FieldProps {
  label: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
}

const Field: React.FC<FieldProps> = ({ label, required, children, error }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
    <label style={{
      fontSize: 11,
      fontWeight: 600,
      color: 'var(--text2)',
      letterSpacing: '0.07em',
      textTransform: 'uppercase',
    }}>
      {label}
      {required && <span style={{ color: 'var(--teal)', marginLeft: 3 }}>✦</span>}
    </label>
    {children}
    {error && <span style={{ fontSize: 12, color: 'var(--red)' }}>{error}</span>}
  </div>
);

export default Field;
